// src/views/BlogDetailPage.tsx
import React from 'react';
import '../styles/App.css';
import BlogDetailComponent from "../components/BlogDetailComponent";
import {Layout} from "../Layout";

const BlogDetailPage: React.FC = () => (
    <Layout>
        <BlogDetailComponent/>
    </Layout>
);

export default BlogDetailPage;
